<template>
    <header class="header mcBgDarkHeader row" v-show="isHidden">
        <nav class="h-100 container">
            <div class="row">
                <div class="col-lg-1 col-sm-2 col-5 float-left d-flex logo pl0">
                    <div class="float-left">
                        <router-link :to="'/deals'">
                            <img src="../assets/minimumcrm-logo-sm-01.png" class="img-fluid d-none d-md-block"/>
                            <p class="d-block d-md-none mb-0 textLogo">minimumcrm</p>
                        </router-link>
                    </div>
                    <div class=" pt-2 float-left d-none">
                        <input type="text" class="form-control bg-transparent contact-search" placeholder="Arama">
                    </div>
                </div>
                <a class="col-2 dropdown mobilMenuBtn headerToggleBtn d-lg-none" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-bars fa-lg"></i></a>
                <div class="col-lg-9 col-sm-5 d-lg-flex headerMenu" :class="{'dropdown-menu':windowWidth<maxTabletSize}">
                    <ul class="nav p-0 menu"> 
                        <li class="nav-item" :class="{active:active==='/deals'}"> 
   
                            <router-link tag="a" :to="windowWidth>maxMobilSize ? '/deals' : '/opportunities'">
                                {{$ml.get('OPPORTUNITIES')}}
                            </router-link>                 
                        </li>
                        <li class="nav-item" @click="active='/activities'" :class="{active:active==='/activities'}"> 
                            
                            <router-link tag="a" to="/activities">
                                {{$ml.get('ACTIVITIES')}}
                            </router-link>                     
                        </li>
                        <li class="nav-item" @click="active='/organizations'" :class="{active:active==='/organizations'}">       
                             
                            <router-link tag="a" to="/organizations">
                                {{$ml.get('COMPAINES')}}
                            </router-link>  
                                        
                        </li>                         
                        <li class="nav-item" @click="active='/contacts'" :class="{active:active==='/contacts'}"> 
                             
                            <router-link tag="a" to="/contacts">
                                {{$ml.get('PERSONS')}}
                            </router-link>   
                        </li>                         
                        <li class="nav-item" @click="active='/products'" :class="{active:active==='/products'}"> 
                              
                            <router-link tag="a" to="/products">
                                {{$ml.get('PRODUCTS')}}
                            </router-link>                         
                        </li>                         
                        <!-- <li class="nav-item" @click="active='/email'" :class="{active:active==='/email'}"> 
                              
                            <router-link tag="a" to="/email">
                                {{$ml.get('E_MAIL')}}
                            </router-link>                         
                        </li> -->
                        <li class="nav-item dNoneMobil" @click="active='/process'" :class="{active:active==='/process'}"> 
                              
                            <router-link tag="a" to="/process">
                                {{$ml.get("PROCESS_V1")}}
                            </router-link>                           
                        </li>
                        <li class="nav-item" @click="active='/timeline'" :class="{active:active==='/timeline'}"> 
                              
                            <router-link tag="a" to="/timeline">
                                {{$ml.get('NEWS_FEED')}}
                            </router-link>                           
                        </li>
                        <li class="nav-item" @click="active='/reports'" :class="{active:active==='/reports'}"> 
                              
                            <router-link tag="a" to="/reports">
                                {{$ml.get('REPORTS')}}
                            </router-link>                           
                        </li>
                                         
                    </ul>
                </div> 

                <div class="col-lg-2 col-sm-7 col-7 d-flex justify-content-end align-items-center"> 
                
                <div class="ml-2 ePosta headerIconDesign">
                    <router-link tag="a" to="/email">
                        <span class="fa fa-envelope ePostaIcon" style="font-size:18px;"></span>
                    </router-link> 
                </div>
                <div class="ml-2 ePosta headerIconDesign whatsapp-header-icon">
                    <router-link tag="a" to="/whatsapp" title="WhatsApp">
                        <span class="fab fa-whatsapp ePostaIcon" style="font-size:20px;"></span>
                    </router-link>
                    <span v-if="whatsappUnreadCount > 0" class="badge badge-danger whatsapp-unread-badge" :title="`${whatsappUnreadCount} okunmamış WhatsApp mesajı`">{{ whatsappUnreadCount > 99 ? '99+' : whatsappUnreadCount }}</span>
                </div>
                
                <div class="ml-2 float-left btn-click dropdown call-center-menu p-0">
                    <div class="d-flex align-items-center ePosta callIconBtn headerToggleBtn justify-content-center" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false">
                        <div class="call-center-icon" v-if="agentStatus==='online'">
                           <span class="fas fa-phone-alt" style="font-size:18px;"></span>
                        </div>
                        <div class="call-center-icon" style="font-size:18px;" v-else-if="agentStatus==='break'">
                           <span class="fas fa-phone-alt" style="font-size:18px;"></span>
                        </div>
                        <div class="call-center-icon" v-else-if="agentStatus==='offline'">
                           <span class=" fas fa-phone-slash"  style="font-size:18px;"></span>
                        </div>
                    </div>
                    <div class="dropdown-menu call-center-dropdown p-0" id="call-center-dropdown">
                        <div class="row call-center-header m-0">
                            <div class="header-textBig col-md-6" id="headerStatus">Çağrı Merkezi
                                <!-- <span>Aktif</span> -->
                            </div>
                            <div class="col-md-6 p-0">
                                <div class="row d-flex justify-content-center">
                                    <div class="d-flex" style="margin-top:13px;">
                                        <div class="d-flex align-items-center user-info px-2"><i class="fas fa-headset pr-2"></i>
                                        {{maxTextLength(userName, 9)}}</div>
                                        <!-- pause -->
                                        <div class="d-flex align-items-center agent-status" id="break"  @click="changeStatus('break')"><span class="fas fa-phone-alt">pause</span></div>
                                        <!-- phone_disabled -->
                                        <div class="d-flex align-items-center agent-status phone-disabled" id="offline"  @click="changeStatus('offline')"><span class="fas fa-phone-slash"></span></div>
                                        <!-- phone_in_talk -->
                                        <div class="d-flex align-items-center agent-status" style="border-top-right-radius:4px; border-bottom-right-radius:4px;" id="online"  @click="changeStatus('online')"><span class="fas fa-phone-alt"></span></div>
                                    </div>
                                </div>
                            </div>
                           
                        </div>
                        <div class="row m-0">
                            <div class="p-0 leftContent">
                                <div class="row m-0">
                                    <div class="col-md-6 pl-0 pr-1 callText text-center" id="all-users" @click="changeListType('all')">
                                        <i class="fas fa-users"></i>
                                        Tüm Kullanıcılar
                                    </div>
                                    <div class="col-md-6 callText text-center last-calls" id="last-calls" @click="changeListType('last')">
                                        <i class="fas fa-history"></i>
                                        Son Aramalar
                                    </div>
                                </div>
                                <div class="scrollable-content px-1" id="scrollable-template" v-if="listContacts==true" v-on:scroll="scrl">
                                    <div class="row m-0 py-2 contact-info align-items-center" v-for="(contact, index) in contactListArray" v-bind:key="index">
                                        <div class="col-md-10">
                                            <div>{{contact.name}} {{contact.surname}} ( {{maxTextLength(contact.organizationName, 10)}} )</div>
                                            <div class="pt-1" style="font-weight:700;">{{contact.gsm}}</div>
                                        </div>
                                        <div class="col-md-2" @click="callFromList(contact.gsm)">
                                            <i class="fas fa-phone-alt" style="font-size:24px;"></i>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="scrollable-content">
                                    <div class="d-flex justify-content-between text-white p-2">
                                        <div class="d-flex historyFilter">
                                            <button type="button" class="btn btn-filter mr-1" :class="{active:historyFilter=='all'}" @click="historyFilter='all'">Tümü</button>
                                            <button type="button" class="btn btn-filter mr-1" :class="{active:historyFilter=='outgoing'}" @click="historyFilter='outgoing'">Giden</button>
                                            <button type="button" class="btn btn-filter mr-1" :class="{active:historyFilter=='incoming'}" @click="historyFilter='incoming'">Gelen</button>
                                            <button type="button" class="btn btn-filter" :class="{active:historyFilter=='not-answered'}" @click="historyFilter='not-answered'">Cevapsız</button>
                                        </div>
                                        <div class="d-flex align-items-center px-2">
                                            <i class="fas fa-search" style="font-size:20px;"></i>
                                        </div>
                                    </div>
                                    <div class="px-2">
                                        <div class="row m-0 py-2 contact-info align-items-center" v-for="(item, index) in filteredHistory" v-bind:key="index">
                                            <div class="d-block"> 
                                                <div class="row m-0 " v-if="item.callStatus==='answered'">
                                                    <div class="col-1 pl-1" v-if="item.callType==='outgoing'">
                                                        <span class="material-icons">call_made</span>
                                                    </div>
                                                    <div class="col-1 pl-1" v-else>
                                                        <span class="material-icons">phone_callback</span>
                                                    </div>
                                                    <div class="col-6 pl-3 pr-0" style="min-width:120px;">
                                                        <!-- <span>{{item.name}} - {{item.orgName}}</span> -->
                                                        <span>{{formatGsm(item.phoneNumber)}}</span>
                                                    </div>
                                                    <div class="col-4">
                                                        <span>{{dateFunc(item.createdAt.$date)}}</span>
                                                        <span>{{timeFunc(item.createdAt.$date)}}</span>
                                                    </div>
                                                    <div class="col-1 p-0 pl-4 d-flex align-items-center" @click="callFromList(formatGsm(item.phoneNumber))">
                                                        <span><i class="fas fa-phone-alt" style="font-size:24px;"></i></span>
                                                    </div>
                                                </div>
                                                <div class="row m-0 " v-if="item.callStatus==='not-answered'">
                                                    <div class="col-1 pl-1">
                                                        <span class="material-icons" style="color:#DA0000;">phone_missed</span>
                                                    </div>
                                                    <div class="col-6 pl-3 pr-0" style="min-width:120px;">
                                                        <!-- <span>{{item.name}} - {{item.orgName}}</span> -->
                                                        <span>{{formatGsm(item.phoneNumber)}}</span>
                                                    </div>
                                                    <div class="col-4 ">
                                                        <span>{{dateFunc(item.createdAt.$date)}}</span>
                                                        <span>{{timeFunc(item.createdAt.$date)}}</span>
                                                    </div>
                                                    
                                                    <div class="col-1 p-0 pl-4 d-flex align-items-center" @click="callFromList(formatGsm(item.phoneNumber))">
                                                        <span><i class="fas fa-phone-alt" style="font-size:24px;"></i></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="p-0">
                                <numerator :page="'header'" :status='agentStatus' @personList="contactList"></numerator>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="ml-2 nav-item dropdown notifications-dropdown notificationDiv ePosta mobilMargin">
                    <a class="nav-link dropdown-toggle pl-0"  id="notifications-dd" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-bell fa-lg text-white" style="font-size:18px;"></i><span class="badge badge-danger count-badge text-danger notificationIcon notificationIconActive" style="font-size:4px !important; top:11px; left:21px; border:2px solid #fff;" >{{notificationsCount}}</span></a>
                    <div class="notificationMenu dropdown-menu dropdown-menu-right dropMenu multiChoose pt-0" style="width:27rem;border:0;box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.15);">
                        <div class="row m-0" style="backgroundColor:#fafafa;">
                            <nav class="">
                                <div class="nav btn-group notification-nav mx-auto d-flex flex-column" role="tablist">
                                    <a class="btn d-flex justify-content-center align-items-center textColor" :class="{activeNotificationTab:activeTab=='deal'}" id="nav-deal-tab" @click="changeTab('deal')" data-toggle="tab" href="#nav-deal" role="tab" aria-controls="nav-deal" aria-selected="true">{{$ml.get('OPORTUNITY')}}</a>
                                    <a class="btn d-flex justify-content-center align-items-center textColor" :class="{activeNotificationTab:activeTab=='activity'}"   id="nav-activity-tab" @click="changeTab('activity')" data-toggle="tab" href="#nav-activity" role="tab" aria-controls="nav-activity" aria-selected="false">{{$ml.get('ACTIVITY')}}</a>
                                    <a class="btn d-flex justify-content-center align-items-center textColor" :class="{activeNotificationTab:activeTab=='reminder'}"  id="nav-reminder-tab" @click="changeTab('reminder')" data-toggle="tab" href="#nav-reminder" role="tab" aria-controls="nav-reminder" aria-selected="false">{{$ml.get('REMINDER')}} <span class="badge badge-danger mt-1 ml-1">{{notificationsCount}}</span></a>
                                    <div class="w-100 h-100" style="border-bottom:1px solid rgba(139,146,158,0.2);"></div>
                                </div>
                            </nav>
                        </div>
                        <div class="tab-content">
                            <div class="tab-pane fade" id="nav-deal" role="tabpanel" aria-labelledby="nav-deal-tab">
                                <div class="notification-card pl-3"  v-for="(deal,index) in deals" v-bind:key="index" @click="openDealCard(deal._id.$oid)">
                                    <!-- <div v-if="$moment(0,'HH').diff(deal.expectedDate.$date, 'days')==0">{{$ml.get('TODAY_DEAL_NOTIFICATION')}}</div> -->
                                    <div class="mb-1 textColor">
                                        <!-- <span class="fa fa-circle mr-2 text-danger f-11"></span> -->
                                        {{maxTextLength(deal.orgId.name, 50)}}</div>
                                    <div class="textColorGri">{{formatDate(deal.expectedDate.$date, 'DD.MM.YYYY, dddd')}} <span class="notificationSpan ml-1 textColor f-12 px-2">{{maxTextLength(deal.title, 40)}}</span></div>
                                </div>
                                <div class="p-3 text-center" v-if="deals.length==0">{{$ml.get('NO_DATA')}}</div>
                            </div>
                            <div class="tab-pane fade" id="nav-activity" role="tabpanel" aria-labelledby="nav-activity-tab">
                                <div class="notification-card"  v-for="(activity,index) in activities" v-bind:key="index" @click="openActivityModal(activity)">
                                    <!-- <div v-if="$moment(0,'HH').diff(activity.dueDate.$date, 'days')==0">{{$ml.get('TODAY_ACTIVITY_NOTIFICATION')}}</div> -->
                                    <div class="textColor mb-1">
                                        <!-- <span class="fa fa-circle mr-2 text-danger f-11"></span> -->
                                    {{activity.subject}}</div>
                                    <div class="textColorGri">{{formatDate(activity.dueDate.$date, 'DD.MM.YYYY')}}
                                        <span class="notificationSpan textColor ml-1 pr-2 f-12"><span class="fa fa-building ml-1 textColorIcon f-11"></span>&ensp;{{maxTextLength(activity.orgId ? activity.orgId[0].name : "Firma seçilmedi", 20)}}</span>
                                        <span v-tooltip.right="$ml.get('APPOINTEE')" class=" notificationSpan ml-1 textColor f-12 px-2"><span class="fas fa-people-arrows textColorIcon f-11"></span>&ensp;{{maxTextLength((users.find(u => u._id.$oid === activity.assignor.$oid).name) + " " + (users.find(u => u._id.$oid === activity.assignor.$oid).surName), 14)}}</span></div>
                                </div>
                                <!-- activity.assignor.$oid -->
                                <div class="p-3 text-center" v-if="activities.length==0">{{$ml.get('NO_DATA')}}</div>
                            </div>
                            <div class="tab-pane fade show active" id="nav-reminder" role="tabpanel" aria-labelledby="nav-reminder-tab">
                                <div v-for="(notification,index) in notificationsMutation" v-bind:key="index" @click="readReminder(notification)">
                                    <div class="notification-card cardBg" :class="{'bg-white':notification.isRead==null || notification.isRead==false}">
                                  
                                    <div class="mb-1 textColor" v-if="notification.reminder.deal!==undefined&&notification.reminder.deal!==null"><span class="fa fa-circle mr-2 f-11 textColorIcon" :class="{'text-danger':notification.isRead==null || notification.isRead==false}"></span><span v-html="$ml.get('DEAL_REMINDER_NOTIFICATION')"></span></div>
                                    <div class="mb-1 textColor" v-if="notification.reminder.activity!==undefined&&notification.reminder.activity!==null"><span class="fa fa-circle mr-2 f-11 textColorIcon" :class="{'text-danger':notification.isRead==null||notification.isRead==false}"></span><span v-html="$ml.get('ACTIVITY_REMINDER_NOTIFICATION')"></span></div>
                                    
                                    <div class=" textColorGri ml-18" v-if="notification.reminder.deal!==undefined&&notification.reminder.deal!==null">{{formatDate(notification.reminder.date.$date, 'DD.MM.YYYY')}} <span class="notificationSpan ml-1 px-2 textColor f-12">{{maxTextLength(notification.reminder.deal.title, 20)}}</span></div>

                                    <div v-if="notification.reminder.activity!==undefined&&notification.reminder.activity!==null" class="textColorGri ml-18">{{formatDate(notification.reminder.date.$date, 'DD.MM.YYYY')}} <span class="notificationSpan ml-1 px-2 textColor f-12">{{maxTextLength(notification.reminder.activity.subject, 20)}}</span></div>
                                    
                                
                                <div class="p-3 text-center" v-if="notificationsMutation.length==0">{{$ml.get('NO_DATA')}}</div>
                                </div>  
                                </div>
                            </div>
                        </div>
                        <div class="row ml-2 mt-2 ">
                            <button class="btn notificationBtn" @click="goToAll()">{{$ml.get('VIEW_ALL')}}</button>
                        </div>
                    </div>
                </div>   
               
                <div class="ml-2 float-left btn-click  dropdown">
                    <div class="d-flex align-items-center headerToggleBtn justify-content-end px-1 ePosta" data-toggle="dropdown" id="user-menu" aria-haspopup="true" aria-expanded="false">
                        <!-- <div class="user-icon">
                            <img src="../assets/min-crm-avatar.jpg" class="rounded-circle" style="padding-top: 5px; padding-bottom: 5px;"> 
                        </div> -->
                        <div class="user-name d-md-block mr-1">
                            <!-- İsimleri güncelleme -->
                            <p class=" m-0 text-center username font-family-bold f-w-normal" :title="userName" >{{filterName(userName)}}</p>
                            <!-- <p class="text-light p-0 m-0 text-center company d-none">İletişim Makinesi</p> -->
                        </div>
                        <div class="user-name-caret d-md-block">
                            <div class="dropdown-pull-right">
                                <i class="fa fa-angle-down text-white f-20"></i>
                            </div>
                        </div>
                    </div>
                    <div class="dropdownSettings dropdown-menu dropdown-menu-right pull-right p-0" style="width: 240px;border:0;box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.15);">
                        <a class="dropdown-item f-w-normal font-family-bold f-14 d-none" href="#">Profil</a>
                        <!-- <router-link tag="a"  to="/settings"><a class="dropdown-item f-w-normal font-family-bold f-14 text-white" href="#">{{$ml.get('SETTINGS')}}</a></router-link> -->
                        <!-- <router-link tag="a"  to="/settings"><a class="dropdown-item f-w-normal font-family-bold f-14 text-white" href="#">{{$ml.get('PERSONAL_SETTINGS')}}</a></router-link>
                        <router-link tag="a"  to="/settings"><a class="dropdown-item f-w-normal font-family-bold f-14 text-white" href="#">{{$ml.get('COMPANY_SETTINGS')}}</a></router-link>
                        <router-link tag="a"  to="/settings"><a class="dropdown-item f-w-normal font-family-bold f-14 text-white" href="#">{{$ml.get('USER_MANAGEMENT')}}</a></router-link>
                        <router-link tag="a"  to="/settings"><a class="dropdown-item f-w-normal font-family-bold f-14 text-white" href="#">{{$ml.get('CALL_CENTER_SETTINGS')}}</a></router-link>
                        <router-link tag="a"  to="/settings"><a class="dropdown-item f-w-normal font-family-bold f-14 text-white" href="#">{{$ml.get('SECURITY_SETTINGS')}}</a></router-link>
                        <router-link tag="a"  to="/settings"><a class="dropdown-item f-w-normal font-family-bold f-14 text-white" href="#">{{$ml.get('3RD_PARTY_SOFTWARE')}}</a></router-link>
                        <router-link tag="a"  to="/settings"><a class="dropdown-item f-w-normal font-family-bold f-14 text-white" href="#">{{$ml.get('WORKFLOW_AUTOMATION')}}</a></router-link>
                        <router-link tag="a" to="/logout"><a class="dropdown-item f-w-normal font-family-bold f-14 text-white" href="#">{{$ml.get('EXIT')}}</a></router-link> -->

                        <ul class="new-dropdown p-0 border-0" style="overflow:hidden;max-height:410px;">
                        <li class="d-flex align-items-center justify-content-between" style="backgroundColor:#fafafa; height:44px;">
                            {{filterFullName(userName)}}
                            <!-- <router-link class="d-flex crm-detail-icon-btn justify-content-center align-items-center" tag="a"  to="/logout"><i class="fas fa-sign-out-alt" style="font-size:16px;" v-tooltip.right="$ml.get('EXIT')"></i></router-link> -->
                            
                        </li>
                          <li class="border-bottom-0 d-flex align-items-center" style="height:40px">
                           <a @click="yonlendir('editPersonalSettings')" class="dropdown-item f-w-normal f-14 pl-0"><i class="fas fa-user ml-1 mr-1" style="width:20px;"></i>{{$ml.get('PERSONAL_SETTINGS')}}</a>
                          </li>
                          <li class="border-bottom-0 d-flex align-items-center" style="height:40px">
                            <a @click="yonlendir('generalCompanySettings')" class="dropdown-item f-w-normal  f-14 pl-0" ><i class="fas fa-building mr-1 ml-1" style="width:20px;"></i>{{$ml.get('COMPANY_SETTINGS')}}</a>
                          </li>
                          <!-- this.$router.push({ path: 'settings', query: { paymentStatus: 'userManagement' } } -->
                          <li class="border-bottom-0 d-flex align-items-center" style="height:40px">
                            <a @click="yonlendir('userManagement')" class="dropdown-item f-w-normal  f-14 pl-0" ><i class="fas fa-users-cog mr-1 ml-1" style="width:20px;"></i>{{$ml.get('USER_MANAGEMENT')}}</a>
                          </li>
                          <li class="border-bottom-0 d-flex align-items-center" style="height:40px">
                            <a @click="yonlendir('callCenterSettings')" class="dropdown-item f-w-normal  f-14 pl-0" ><i class="fas fa-phone-alt mr-1 ml-1" style="width:20px;"></i>{{$ml.get('CALL_CENTER_SETTINGS')}}</a>
                          </li>
                          <li class="border-bottom-0 d-flex align-items-center" style="height:40px">
                            <a @click="yonlendir('auditPage')" class="dropdown-item f-w-normal  f-14 pl-0" ><i class="fas fa-shield-alt mr-1 ml-1" style="width:20px;"></i>{{$ml.get('SECURITY_SETTINGS')}}</a>
                          </li>
                          <li class="border-bottom-0 d-flex align-items-center" style="height:40px">
                            <a @click="yonlendir('thirdPartySettings')" class="dropdown-item f-w-normal f-14 pl-0" ><i class="fas fa-plug mr-1 ml-1" style="width:20px;"></i>{{$ml.get('INTEGRATION')}}</a>
                          </li>
                          <li class="border-bottom-0 d-flex align-items-center dNone" style="height:40px">
                            <a @click="yonlendir('workflowManagement')" class="dropdown-item f-w-normal  f-14 pl-0"><i class="fas fa-stream mr-1 ml-1" style="width:20px;"></i>{{$ml.get('WORKFLOW_AUTOMATION')}}</a>
                          </li>
                          <li class="border-bottom-0 d-flex align-items-center dNone" style="height:40px">
                            <a @click="yonlendir('userGuide')" target="_blank" class="dropdown-item f-w-normal  f-14 pl-0"><i class="fa fa-info-circle mr-1 ml-1" style="width:20px;"></i>Kullanım Klavuzu</a>
                          </li>
                          <li class="border-bottom-0 border-top d-flex align-items-center" style="height:40px">
                           <a @click="yonlendir('logout')" class="dropdown-item f-w-normal f-14 pl-0"><i class="fas fa-sign-out-alt ml-1 mr-1" style="width:20px;"></i>{{$ml.get('EXIT')}}</a>
                          </li>
                  
                      </ul>

                        <div v-if="windowWidth<maxTabletSize" class="languagepicker">
                            
                        </div>
                    </div>
                </div>
                </div> 
            </div>
        </nav>
        <div class="notificationDropDownModal modal fade" id="updateActivity" ref="newActivity" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:750px!important;">
                <div class="modal-content" style="width:100%;height:100%; position:fixed; overflow-y:auto; overflow-x:hidden;">
                    <newActivity pageIs="dataType" here="notificationDropDownModal" parentComp="header" :clearModal="clearModal" :listenStateStatus="this.listenStateStatus" :methods='type' :user="user" :users="users" @refleshData="getActivitiesF()" ></newActivity>
                </div>
            </div>
        </div>
    </header>
</template>
<script>
import axios from 'axios'
import { mapState } from 'vuex'
import {mapActions,mapGetters} from 'vuex'
import newActivity from '@/components/newActivity'
import Numerator from './numerator.vue'
import moment from 'moment'
import { markRaw } from 'vue'
//import VueSocketIO from 'vue-socket.io'
export default {
    name: 'Header',
    components:{
        'newActivity':newActivity,
        Numerator
    },
    data () {
        return {
            active:"",
            isHidden:true,
            name:'',
            permissionsId:"",
            surName:"",
            notificationsCount:0,
            type: "save",
            clearModal:false,
            listenStateStatus:true,
            customFields:[],
            activeTab:'reminder',
            contactListArray:[],
            listContacts:true,
            callHistoryList:[],
            filteredHistory:[],
            contactsArr:[],
            sipSettings:[],
            checkStatusArr:[],
            historyFilter:'all',
            agentStatus:'offline',
            socket: null,
            whatsappUnreadCount: 0
        }
    },
    computed:{
        ...mapState([
            'baseUrl',
            'editLine',
            'editLineStatu',
            'windowWidth',
            'maxMobilSize',
            'maxTabletSize',
        ]),
        notificationsMutation(){
            
            var unReadNotifications = this.notifications.filter(r => {
                return r.isRead!==true
            })
            this.notificationsCount = unReadNotifications.length
           
            return this.notifications.slice(0,5)
            
            
        },
        ...mapGetters(['deals','activities','notifications','user','users', 'userName','sipSettingsId'])
    },
    mounted(){
        window.addEventListener('sip-agent-status-changed', this.syncSipAgentStatus)
        window.addEventListener('whatsapp-unread-count-refresh', this.refreshWhatsAppUnreadCount)
        $("#call-center-dropdown").click(function(e){
            e.stopPropagation();
        })
        this.getContactsF()
        this.getSipSettingsF()
    },
    beforeUnmount(){
        window.removeEventListener('sip-agent-status-changed', this.syncSipAgentStatus)
        window.removeEventListener('whatsapp-unread-count-refresh', this.refreshWhatsAppUnreadCount)
        if(this.socket){
            this.socket.disconnect()
            this.socket = null
        }
    },
    created(){ 
        this.$root.$refs.Header = this
        this.$root.$moment.locale(this.$ml.current);
        this.path()
        this.refreshWhatsAppUnreadCount()
        this.getNotificationsF().finally(()=>{
            this.connectSocket()
        })
    },
    methods:{
        getCompanyId(){
            const companyId = this.user && this.user.cid
            if(companyId && companyId.$oid){
                return companyId.$oid
            }
            return companyId || ''
        },
        connectSocket(){
            if(this.socket) return
            const userId = localStorage.cuid || ''
            const companyId = this.getCompanyId()
            const query = `user_id=${encodeURIComponent(userId)}&company_id=${encodeURIComponent(companyId)}`
            const socket = markRaw(io(process.env.SOCKET_URL,{query, path: process.env.SOCKET_PATH}))
            this.socket = socket

            socket.on("reminder_notification",()=>{
                this.getNotificationsF()
            })
            socket.on("call_start",(msg)=>{
                // FIXME: Online/offline kontrolu vs. yapilmali
                var tel = msg.phone
                this.$root.$refs.sip.call(tel)
            })
            socket.on("whatsapp_new_message",(msg)=>{
                this.refreshWhatsAppUnreadCount()
                window.dispatchEvent(new CustomEvent('whatsapp_new_message', {detail: msg || {}}))
            })
            socket.on("whatsapp_status_update",(msg)=>{
                this.refreshWhatsAppUnreadCount()
                window.dispatchEvent(new CustomEvent('whatsapp_status_update', {detail: msg || {}}))
            })
        },
        async refreshWhatsAppUnreadCount(){
            try{
                const response = await axios({
                    method:'POST',
                    url:'/getWhatsAppConversations',
                    baseURL:this.baseUrl,
                    data:{limit:100, skip:0},
                    withCredentials:true
                })
                const data = response && response.data ? response.data : {}
                const content = data.content || data
                const conversations = content.conversations || content.items || content.results || []
                this.whatsappUnreadCount = Array.isArray(conversations)
                    ? conversations.reduce((count, conversation) => count + Number(conversation.unread_count || conversation.unread || conversation.unreadCount || 0), 0)
                    : 0
            }catch(error){
                this.whatsappUnreadCount = 0
            }
        },
        syncSipAgentStatus(event){
            if(event && event.detail && event.detail.status){
                this.agentStatus = event.detail.status
            }
        },
        goToAll(){
            this.setNotificationTab(this.activeTab)
            this.$router.push('/notifications').catch(()=>{});
        },
        yonlendir(tabMenu){
            if(tabMenu=="userGuide"){
                //  window.location.href=("https://www.minimumcrm.com/kullanim-rehberi-crm-kullanimi")
                window.open("https://www.minimumcrm.com/kullanim-rehberi-crm-kullanimi", "_blank");
            }else if(tabMenu=="logout"){
                this.$router.push('/logout')
            }
            else{
                // this.$router.push({ name: 'settings', query: { paymentStatus: tab }})
                // this.$root.$refs.formGenerator.setActiveTabAs(tab) 
                // Settings reads the selected tab from the route query during creation.
                // A delayed root-ref call may run after the Settings component has
                // unmounted in Vue 3, causing a white-screen runtime error.
                this.$router.push({ path: '/settings', query: { tab: tabMenu } }).catch(()=>{});
            }
            
           
            
        },
        openDealCard(id){
            let routeData = this.$router.resolve({path: '/dealCard/'+id});
            window.open(routeData.href, '_blank');
        },
        openActivityModal(activity){
            var data = activity
            data["edit"]=true
            data["notificationModal"]=true
            this.$store.dispatch('editLine', data)
            let statu=true
            this.$store.dispatch('editLineStatu', statu)
           
            $('#updateActivity').modal('show')
            $('#activity-tab').tab('show');
            document.querySelector(".header").style.position="inherit";
            //    $(".modal-backdrop").style.zIndex= "995";
            //    $(".modal-backdrop").modal("hide");
            // let routeData = this.$router.resolve({path: '/notifications'});
            // window.open(routeData.href);
        },
        readReminder(notification){
            var form = {}
            form.notificationId = notification._id.$oid
            form.isRead = true
            var reminderType = ''
            if(notification.reminder.activity!==undefined&&notification.reminder.activity!==null){
                reminderType = 'activity'
            }else if(notification.reminder.deal!==undefined&&notification.reminder.deal!==null){
                reminderType = 'deal'
            }else{
                return false
            }
            this.updateNotification(form).then((res)=>{
                return res
            }).then((res)=>{
                console.log("updateNotification on read reminder res")
                console.log(res)
                if(res.status.code=='0'){
                    if(reminderType=='activity'){
                        this.openActivityModal(notification.reminder.activity)
                    }else if(reminderType=='deal'){
                        this.openDealCard(notification.reminder.dealId.$oid)
                    }
                    this.getNotificationsF()
                }
                
            })
        },
        changeTab(tab){
            this.activeTab = tab
            if(tab=="deal"){
                this.getDealsF()
            }else if(tab=='activity'){
                this.getActivitiesF()
            }else if(tab=='reminder'){
                this.getNotificationsF()
            }
        },
        getDealsF(){
            
            var form = {}
            var filterObj = {}
            filterObj.searchMode = 'deals'
            filterObj.name = 'default'
            var andsList = []
            var andsObj ={}
            andsObj.fieldName = "expectedDate"
            andsObj.filterType = "deals"
            andsObj.operator = "equals"
            var valueObj = {}
            var today = new Date()
            var startDate = new Date(today.getTime() - 3*24*60*60000)
            var endDate = new Date(today.getTime() + 3*24*60*60000)
            valueObj.startDate = today
            valueObj.endDate = endDate
            andsObj.value=valueObj
            andsList.push(andsObj)
            filterObj.ands = andsList
            form.pagingSize = 5
            form.pagingOffset = 0
            form.sort = "expectedDate"
            form.sortType= 1
            form.filter = filterObj
            this.getDealsForTable(form).then((res)=>{
                return res
            }).then((res)=>{
                console.log('getDeals then response')
                console.log(res)
                if(res.status.code=="0"){
                    
                }
            })
        },
        getActivitiesF(){
            var form = {}
            var filterObj = {}
            filterObj.searchMode = 'activities'
            filterObj.name = 'default'
            var andsList = []
            var andsObj ={}
            andsObj.fieldName = "dueDate"
            andsObj.filterType = "activities"
            andsObj.operator = "equals"
            var valueObj = {}
            var today = new Date()
            var startDate = new Date(today.getTime() - 3*24*60*60000)
            var endDate = new Date(today.getTime() + 3*24*60*60000)
            valueObj.startDate = today
            valueObj.endDate = endDate
            andsObj.value=valueObj
            andsList.push(andsObj)
            filterObj.ands = andsList
            form.pagingSize = 5
            form.pagingOffset = 0
            form.sort = "dueDate"
            form.sortType= 1
            form.filter = filterObj
            this.getActivities(form).then((res)=>{
                return res
            }).then((res)=>{
                console.log('getActivities then response')
                console.log(res)
                if(res.status.code=="0"){
                    this.customFields = res.content.customFields
                }
                
            })
        },
        getNotificationsF(){
            var form = {}
            return this.getNotifications(form).then((res)=>{
                return res
            }).then((res)=>{
                // console.log('getNotifications then response')
                // console.log(res)
            })
        },
        refresh:function(){
            window.location.reload();
        },
        path:function(){
            if(this.$route.path==="/login"||this.$route.path==="/renewPassword"||this.$route.path==="/forgotpassword"||this.$route.path==="/requestPayment"||this.$route.path==="/activation"||this.$route.path==="/signup"||this.$route.query.key!==undefined){
                this.isHidden=false
            }else{
                this.isHidden=true
            }
            // if(this.$route.path==="/notifications"){
            //     console.log("girildi atakan");
            //     $('.notificationDiv').addClass('notificationDivClass')
            //     $('.notificationIconActive').addClass('notificationIconActive')
            // }else{
            //     $('.notificationDiv').removeClass('notificationDivClass')
            //     $('.notificationIconActive').removeClass('notificationIconActive')
            // }
            this.active=this.$route.path
            if(this.$route.path==="/dealCard/"+this.$route.params.dealId || this.$route.path==="/opportunities"){
                this.active="/deals"
            }else if(this.$route.path==="/organizationCard/"+this.$route.params.orgId){
                this.active="/organizations"
            }else if(this.$route.path==="/contactCard/"+this.$route.params.contactId){
                this.active="/contacts"
            }
        },
        contactList(obj){
            this.contactListArray=obj
        },
        scrl: function(){
            
            const scrollYEmit = document.getElementById('scrollable-template').scrollTop
            const clientHeightEmit = document.getElementById('scrollable-template').clientHeight
            const scrollHeightEmit = document.getElementById('scrollable-template').scrollHeight
            var previousScrollPosition = clientHeightEmit
            var currentScrollPosition = scrollYEmit + clientHeightEmit
            if (currentScrollPosition>previousScrollPosition) {
                this.$emit('scrolled',scrollYEmit,clientHeightEmit,scrollHeightEmit)
                this.$root.$refs.numerator.scrollfunctionOfNumerator(scrollYEmit,clientHeightEmit,scrollHeightEmit)
            }  
        },
        changeListType(type){
            var list_all = document.querySelector("#all-users");
            var list_last_calls = document.querySelector("#last-calls");
            if(type==='all'){
                this.listContacts=true
                list_all.setAttribute("class", "col-md-6 pl-0 pr-1 callText text-center");
                list_last_calls.setAttribute("class", "col-md-6 callText text-center last-calls");
            }
            else{
                this.listContacts=false
                list_all.setAttribute("class", "col-md-6 pl-0 pr-1 callText text-center all-users");
                list_last_calls.setAttribute("class", "col-md-6 callText text-center");
            }
        },
        callFromList(data){
            if(this.agentStatus === 'online'){
                var tel = "90" + data.substring(data.length - 10)
                this.$root.$refs.sip.call(tel)
            }
            else{
                alert('Şuanda çevrimiçi değilsiniz!')
            }
        },
        dateFunc(val){ 
            let date = moment(val, "YYYY-MM-DDTHH:mm:ss.SSSSZ", true).format('L')
            return date;
        },
        timeFunc(val){
            let time = moment(val).utcOffset('+0300').format('HH:mm')
            return time;
        },
        formatGsm(val){
            if(typeof val == 'string'){
                let gsm = val.substring(val.length - 10)
                return gsm;
            }
        },
        callHistory(){
            axios({
                method:'POST',
                url:'/getCallHistories',
                baseURL: this.baseUrl,
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==="0"){
                    let mergedArr = []
                    for(let item of res.data.content.callHistories){
                        let obj = {}
                        let mergedObj = {...item, ...obj}
                        mergedArr.push(mergedObj)
                    }
                    this.callHistoryList = mergedArr
                    this.filteredHistory = this.callHistoryList.reverse()
                    
                }else{
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc
                    })
                }
            })
        },
        getContactsF(num){
            var params = {}
            let filterEnd={
                "searchMode":"contacts",
                "name":"default",
                "ands":[{
                    fieldName: "gsm",
                    filterType: "contacts",
                    operator: "contains",
                    value: num
                }]
            }
            params.pagingSize=30
            params.pagingOffset=0
            // params.filter=filterEnd
            axios({
                method:'POST',
                url:'/getContacts',
                baseURL: this.baseUrl,
                data:params,
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==="0"){
                    this.contactsArr = res.data.content.contacts
                    this.callHistory()
                }else{
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc
                    })
                }
            })
        },
        getSipSettingsF(){
            axios({
                method:'POST',
                url:'/getSipSettings',
                baseURL: this.baseUrl,
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==="0"){
                    this.sipSettings = res.data.content.settings
                    // localde aşağıdaki metodu yoruma al
                    this.getAgents()
                }else{
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc
                    })
                }
            })
        },
        getAgents(){
            axios({
                method:'POST',
                url:'/getCompanySipAgentsWithStatus',
                baseURL: this.baseUrl,
                data:{
                    blockLoadingBar:true
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data){
                    this.checkStatusArr = []
                    for(let setting of this.sipSettings){
                        for(let agent of res.data){
                            if(setting._id.$oid === agent.id && agent.status === 'online'){
                                this.agentStatus = 'online'
                            }
                            else if(setting._id.$oid === agent.id && agent.status === 'busy') {
                                this.agentStatus = 'break'
                            }
                        }
                    }
                }else{
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc
                    })
                }
            })
        },
        updateRindapCallTaskF(form){

            form.blockLoadingBar = true

            axios({
                method:'POST',
                url:'/updateRindapCallTask',
                baseURL: this.baseUrl,
                data:form,
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data){
                   
                }else{
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc
                    })
                }
            })
        },
        changeStatus(status){
           if(status === 'offline'){
            this.$root.$refs.sip.disconnect()
           }
           else if(status === 'break'){
            this.$root.$refs.sip.break()   
           }
           else{
            this.$root.$refs.sip.agentRegister()
           }
        },
        formatDate(value, format) {
            return this.$moment(value).format(format);
        },
        filterFullName:function(value){
            if ( value && value.length > 13 ) {
                return value.substring(0,13) + '...'
            } else {
                return value || ''
            }
        },
        filterName:function(value){
            if (!value) return '';
            const firstLetters = value.split(/\s+/).map((word) => { return word && word[0] ? word[0].toUpperCase() : ''; }).join("");
            return firstLetters;
        },
        maxTextLength:function(value,max){
            if ( value && value.length > max ) {
                return value.substring(0,max) + '...'
            } else {
                return value || ''
            }
        },
        
        ...mapActions(['getDealsForTable','getActivities','getNotifications','updateNotification','setNotificationTab'])
    },
    watch: {
        '$route': 'path',
        historyFilter:function(){
            if(this.historyFilter==="all"){
                this.filteredHistory=this.callHistoryList
            }
            else if(this.historyFilter==="outgoing"){
                let filterArr = []
                for(let item of this.callHistoryList){
                    if(item.callType==="outgoing"){
                        filterArr.push(item)
                    }
                }
                this.filteredHistory=filterArr
            }
            else if(this.historyFilter==="incoming"){
                let filterArr = []
                for(let item of this.callHistoryList){
                    if(item.callType==="incoming"){
                        filterArr.push(item)
                    }
                }
                this.filteredHistory=filterArr
            }
            else if(this.historyFilter==="not-answered"){
                let filterArr = []
                for(let item of this.callHistoryList){
                    if(item.callStatus==="not-answered"){
                        filterArr.push(item)
                    }
                }
                this.filteredHistory=filterArr
            }
        },
        agentStatus:function(){
            var status_online = document.querySelector("#online");
            var status_break = document.querySelector("#break");
            var status_offline = document.querySelector("#offline");
            
            if(this.agentStatus === 'offline'){
                this.agentStatus = 'offline'
                status_online.setAttribute("class", "d-flex align-items-center agent-status");
                status_break.setAttribute("class", "d-flex align-items-center agent-status");
                status_offline.setAttribute("class", "d-flex align-items-center phone-disabled");
            }
            else if(this.agentStatus === 'break'){
                this.agentStatus = 'break'
                status_online.setAttribute("class", "d-flex align-items-center agent-status");
                status_break.setAttribute("class", "d-flex align-items-center pause");
                status_offline.setAttribute("class", "d-flex align-items-center agent-status");
            }
            else{
                this.agentStatus = 'online'
                status_online.setAttribute("class", "d-flex align-items-center phone-active");
                status_break.setAttribute("class", "d-flex align-items-center agent-status");
                status_offline.setAttribute("class", "d-flex align-items-center agent-status");
            }
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#notifications-dd::after{
    content:none;
}
.notifications-dd{
    position:relative
}
.nav-link{
    padding: 0;
}
/* .modal-backdrop{
    z-index:1 !important;
}
.modal-backdrop.show{
    z-index:1 !important;
} */
.modal-header{
    background-color:#f3f6f9;
    position: sticky;
    top: 0;
    z-index: 1;
}
.username{
    background-color: #fff;
    border-radius: 15px;
    padding: 4px;
    color: #3767A0;
    font-size: 17px;
}
.notificationMenu.show{
    top: 21px !important;
    left:10px !important;
}
.dropdownSettings.show{
    top:8px !important;
}
.notificationSpan{
    background-color:#eff3fa; 
    padding:2px 4px;
    border-radius:4px;
}
.ml-18{
    margin-left: 18px;
}
.textColor{
    color: #333333;
}
.textColorGri{
    color: #868f9a;
}
.textColorIcon{
    color: #606f8c;
}
.cardBg{
    background-color: #fafafa;
}
.notificationDivClass{
    background-color: rgba(255, 255, 255, 0.2);
    padding-top: 30px !important;
    padding-bottom: 30px !important;
    border-radius: 0;
}
.ePosta{
    min-width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: -5px;
}
.ePosta:hover{
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 8px;
}
.ePosta:active{
    background-color: rgba(255, 255, 255, 0.2);
    padding-top: 30px;
    padding-bottom: 30px;
    border-radius: 0;
}
.ePostaIcon{
    color:#fff;
    font-size: 17px;

}
.whatsapp-header-icon{
    position: relative;
}
.whatsapp-unread-badge{
    position: absolute;
    top: 1px;
    right: -3px;
    min-width: 16px;
    padding: 2px 4px;
    border: 2px solid #fff;
    border-radius: 10px;
    font-size: 10px;
    line-height: 1;
}
.notificationBtn{
    background-color: #F4FAFE;
    color:#1991EB;
    font-weight: 700;
}
.notificationBtn:hover{
    background-color: #D1E9FB;
}
.notificationIconActiveClass{
    top:20px !important;
}
.count-badge{
    position:absolute;
    top:1px;
    left:10px;
    border-radius: 7px;
}
.notification-card{
    position: relative;
    color:#7F8FA4;
    border-radius: 4px;
    padding:12px;
    font-size:13px;
    cursor: pointer;
    border-bottom: 1px solid rgba(139, 146, 158, 0.2);
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.notification-card i{
    position: absolute;
    top:15px;
    right:15px;
}
.notifications-dropdown .dropdown-menu{
    width: 30rem;
    right:0;
}
.notification-nav>.btn-primary:not(:disabled):not(.disabled).active, .notification-nav>.btn-primary:not(:disabled):not(.disabled):active{
    background-color: #273142;
    border-color: #273142;
}
.activeNotificationTab{
    border-bottom: 0 !important;
    background-color: #fff;
    border-left: 1px solid rgba(139, 146, 158, 0.2);;
}
.notification-nav>.btn{
    width: 120px;
    height: 48px;
    border-bottom:1px solid rgba(139, 146, 158, 0.2);
    border-right: 1px solid rgba(139, 146, 158, 0.2);
}
.notification-nav>.btn-primary{
    background-color: #3767A0;
    border-color: #3767A0;
}
.notification-nav{
    height:48px!important;
}
.icon-top-minus-2{
    margin-top: -2px!important;
}
.dropdown-pull-right {
  float: right !important;
  right: 0;
  left: auto;
}
.dropdown-pull-right>.dropdown-menu {
  right: 0;
  left: auto;
}
.contact-search {
    border-radius: 16.5px;
    font-family: "font-family-bold";
    font-size: 11px;
    border-color: rgba(102, 208, 255, 0.7);
    height: 28px;
    width: 155px!important;
    margin-top: 3px;
    margin-left: 40px;
}
.menu{
    align-items: center;
}
.menu li{
    margin: 0 4px;
}
.menu li a{ 
    color:#FFF;
    font-size: 18px;
    padding: 12px 12px;
    border-radius: 8px;
    cursor: pointer;
    margin: 0;
    font-weight: 500;
}
.menu li a:hover{
    text-decoration: none;
    background-color: rgba(255, 255, 255, 0.20);
    color: #FFF;
    padding:12px;
}
.menu li.active a{
    background-color: #FFF;
    color: #1991EB;
    padding-top: 24px;
    padding-bottom: 24px;
    border-radius: 0;
}
.profile{
    float: right;
    margin-right: 20px;
}
.header {
    height: 60px;
    position: sticky;
    top: 0;
    z-index: 998;
}
.header nav>div {
    height: 60px;
    align-items: center;
}
.small-logo{
    margin-left: -24px;
}
.big-logo{
    margin-left: -48px;
}
.light-blue-icon-color:before {
    color: #66D0FF!important;
}
.dropdown-item:focus, .dropdown-item:hover{
    background-color: unset!important;
}
#headerMenu:before{
    color: white!important;
    margin-left: 5px;
}
.user-icon>img{
    width:27px!important;
    margin-right: 5px;
}
.languagepicker span{
    color: #FFF;
}
.languagepicker span img {
	margin-left: 5px;
    width: 25px;
}
.roundborders {
	border-radius: 5px;
}
.large:hover {
	height: 245px;
}
.call-center-icon {
    padding: 6px;
    border-radius: 50%;
    color: #FFF;
}
.call-center-dropdown {
    background: #333;
    width: 650px;
    top: 5px !important;
    left: -250% !important;
    margin-left: -325px;
    border-radius: 8px;
    border: none;
}
.call-center-header {
    background: #0D0D0D;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
}
.leftContent {
    background: #242424;
    width: 410px;
    height: 420px;
    border-right: 1px solid #4F4F4F;
    border-bottom-left-radius: 8px;
}
.header-textBig {
    color: #FFFFFF;
    font-size: 20px;
    font-weight: 700;
    padding: 1.5rem 1.25rem;
}
.callText {
    color: #FFF;
    font-size: 14px;
    font-weight: 700;
    padding: 1.43rem;
}
.all-users {
    border-right: 1px solid #4F4F4F;
    border-bottom: 1px solid #4F4F4F;
    background: #333333;
}
.last-calls {
    border-left: 1px solid #4F4F4F;
    border-bottom: 1px solid #4F4F4F;
    background: #333333;
}
.contact-info {
    color: #FFF;
    font-size: 16px;
    border-bottom: 1px solid #333333;
}
.user-info {
    background: #C4C4C4;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}
.agent-status{
    background: #5C5C5B;
    border-right: 1px solid #25252580;
    color: #FFF;
    padding: .7rem;
}
.pause{
    background: #FFC40D;
    border-right: 1px solid #25252580;
    color: #FFF;
    padding: .7rem;
}
.phone-disabled{
    background: #262626;
    border-right: 1px solid #25252580;
    padding: .7rem;
    color: #FFF;
}
.phone-active{
    background: #00C61B;
    color: #FFF;
    padding: .7rem;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}
.scrollable-content {
    box-sizing: border-box;
    height: 356px;
    overflow-y: scroll;
    border-bottom-left-radius: 8px;
}
/* Hide scrollbar for Chrome, Safari and Opera */
.scrollable-content::-webkit-scrollbar {
    display: none;
}
/* Hide scrollbar for IE, Edge and Firefox */
.scrollable-content {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
.historyFilter .active,.historyFilter button:hover{
    background: #1A1A1A;
    color: white;
}
.agentStatus .active{
    background: #1A1A1A;
    color: white;
}
.btn-filter {
    background: #4D4D4D;
    color: white;
}
@media (min-width: 768px) {
}
@media (min-width: 992px) {
    .menu li a{ 
        font-size: 13px;
    }
    .headerMenu {
        position: inherit !important;
        top: inherit !important;
        left: inherit;
        transform: inherit !important;
    }
    
}
@media (min-width: 1200px) {
    .menu li a{
        font-size:15px;
    }
}
@media (max-width: 700px){
    .callIconBtn{
        /* display: none !important; */
        visibility: hidden !important;
    }
}
@media (min-width: 550px) and (max-width: 700px){
    .notifications-dropdown{
        display: flex;
        justify-content: center;
        padding: 0;
        margin-right: -2%;
    }
    .headerIconDesign{
        display: flex;
        justify-content:center;
        padding: 0;
        margin-right: -22%;
    }
}
@media (max-width: 992px) {
    /*Header*/
    .logo {
        position: absolute;
        left: 46%;
        transform: translateX(-50%);
    }
    /*.call-center-menu {
        position:absolute;
        left: 54%;
        transform: translateX(-50%);
    }
*/
    .call-center-icon {
        font-size: 14px;
    }
    .header nav>div{
        justify-content: space-between;
    }
    .headerToggleBtn+div.show {
        background-color: #3766a0;
        z-index: 9;
        display: block !important;
    }
    .menu {
        display: block;
    }
    .menu li {
        display: block;
        width: 100%;
        float: left;
        font-size: 23px;
    }
    .menu li a{
    padding: 8px;
    
    }
    .menu li.active a{
    padding-top: 4px;
    padding-bottom: 4px;
    }
    .headerToggleBtn{
        color: #FFF;
        display: flex;
        height: 60px;
        align-items: center;
        font-size: 22px;
    }
    .mobilMenuBtn:hover {
        color: #FFF;
        text-decoration: none;
    }
    .show .mobilMenuBtn i:before{
        content: "\f00d";
    }
    .languagepicker {
        padding: 3px 24px;
        font-weight: 700;
        font-size: 14px;
    }
    .header{
        position: fixed;
        width: 100%;
        top: 0;
        z-index: 99;
    }
    .notifications-dropdown .dropdown-menu {
        transform: inherit !important;
        top: 58px !important;
        width: 100%;
        position: fixed !important;
    }
    .headerMenu{
        display: none;
        background-color: #fafafa !important;
        width: 50%;
        box-shadow: rgba(0, 0, 0, 0.15) 0px 4px 25px;
    }
    .menu li{
        line-height: 40px;
        border-radius: 8px;
    }
    .menu li a{
        color: #53565e !important;
        font-weight: 450;
    }
    .menu li.active a{
        background-color: #f2f2f2;
        border-radius: 4px;
        
        
    }
    .nav-item.active{
        background-color: #f2f2f2;
        width: 90%;
    }
    .headerMenu > ul > li {
        margin-left: 12px;
    }
    .notificationIcon{
        top:0px !important;
        left: 12px !important;
    }
}
@media (min-width: 768px) and (max-width: 992px) {
    .notifications-dropdown{
        display: flex;
        justify-content: center;
        padding: 0;
        margin-right: -2%;
    }
    .headerIconDesign{
        display: flex;
        justify-content:center;
        padding: 0;
        margin-right: -4%;
    }
     .call-center-menu{
        display: flex;
        justify-content:center;
        padding: 0;
        margin-right: -4%;
    }
}
@media (max-width: 768px) {
    .notification-nav>.btn{
        width: initial;
    }
    .textLogo{
        font-size:21px;
        color:#FFF;
        font-weight: 600;
    }
    .logo{
        left: 38% !important;
    }
}
@media (min-width: 701px) and  (max-width: 768px) {
    .notifications-dropdown{
        display: flex;
        justify-content: center;
        padding: 0;
        margin-right: -4%;
    }
    .headerIconDesign{
        display: flex;
        justify-content:center;
        padding: 0;
        margin-right: -8%;
    }
     .call-center-menu{
        display: flex;
        justify-content:center;
        padding: 0;
        margin-right: -7%;
    }
}
@media (min-width: 490px) and (max-width: 550px){
    .notifications-dropdown{
        margin-right: -4%;
    }
    .headerIconDesign{
        margin-right: -25%;
    }
}
@media (min-width: 400px) and (max-width: 490px){
    .notifications-dropdown{
        margin-right: -4%;
    }
    .headerIconDesign{
        margin-right: -27%;
    }
}

/*@media (min-width: 400px) and (max-width: 430px){
    .headerIconDesign{
        display: flex;
        justify-content: flex-end;
    }
}
@media (min-width: 431px) and (max-width: 489px){
    .headerIconDesign{
        display: flex;
        justify-content: flex-end;
        padding-right: 4px;
    }
}*/
@media (max-width: 400px){
    .notifications-dropdown{
        margin-right: -5%;
    }
    .headerIconDesign{
        margin-right: -35%;
    }
}
@media (max-width: 576px){
  .dNone{
    display: none !important;
  }
  .pl0{
      padding-left: 0;
  }
  .mobilMargin{
      margin-left: 1rem !important;
      margin-right: 0.25rem !important;
  }
}
</style>
